import { render, staticRenderFns } from "./MypacksItem.vue?vue&type=template&id=50b0f0e0&"
import script from "./MypacksItem.vue?vue&type=script&lang=js&"
export * from "./MypacksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports